import { memo } from "react"

import { Form } from "react-bootstrap"

import NotificationActionCell from "./NotificationActionCell"
import NotificationEventCell from "./NotificationEventsCell"
import NotificationMethodCell from "./NotificationMethodsCell"
import NotificationNameCell from "./NotificationNameCell"
import NotificationContactData from "../../../api/Randoms/Notification/NotificationContactData"
import NotificationMode from "../../../api/Randoms/Notification/NotificationMode"
import { useNotificationContactsActions } from "../../../api/Randoms/Notification/useNotificationContactsActions"
import FormatPhone from "../../../formatters/FormatPhone"

interface NotificationGridRowProps {
  contact: NotificationContactData
}

function NotificationGridRow({ contact }: NotificationGridRowProps) {
  const { selectContacts } = useNotificationContactsActions()
  const { ContactID, selected, Email, Phone, NotificationMethods, NotificationEvents, NotificationMode: mode } = contact

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    selectContacts([Number(e.target.value)], e.target.checked)
  }

  return (
    <tr>
      <td>
        <Form.Check
          type="checkbox"
          name="random-notification-contact"
          id={`rnc_${ContactID}`}
          className="abc-checkbox abc-checkbox-primary d-flex justify-content-center align-middle"
          value={ContactID}
          label=""
          checked={selected}
          readOnly
          onChange={handleChange}
        />
      </td>
      <td>
        <NotificationNameCell firstName={contact.FirstName} lastName={contact.LastName} />
      </td>
      <td>{Email}</td>
      <td>{FormatPhone(Phone)}</td>
      <td>{NotificationMethods && <NotificationMethodCell methods={NotificationMethods} />}</td>
      <td>{NotificationEvents && <NotificationEventCell types={NotificationEvents} />}</td>
      <td className="text-center text-uppercase small">{NotificationMode[mode]}</td>
      <td>
        <NotificationActionCell contact={contact} />
      </td>
    </tr>
  )
}

export default memo(NotificationGridRow)
